/**
 *  Normalizes media urls.
 *  Replaces any older assets that parsely gives back in response. The media library has  been added and change in many different places and environments.
 *  The folder structure however has not had changes. Only the domains changed. The files remained for the most part so we are replacing the urls.
 */


/**
 * Configuration array. Add URLs here to check.
 *
 * @type {string[]}  List of strings to look for and be replaced with the correct url.
 */
const urlsToBeReplaced = [
    'dev.sb.adweek.com',
    'dev.adweek.com',
    'stage.sb.adweek.com',
    'stage.adweek.com'
];

/**
 *
 * @param {string} url
 * @returns {string}
 */
export default function replaceUrls( url ) {

    urlsToBeReplaced.forEach( function( value ) {

        url = url.replace( value, 'www.adweek.com' );

    });

    return url;

}

